// extracted by mini-css-extract-plugin
export default {"melodyVideo":"BN-z","isFullWidth":"CN-z","landingPageVideo":"DN-z","play":"EN-z","iframeVideo":"FN-z","playHidden":"GN-z","fullwidth":"HN-z"};